import React from 'react';

const Deprecated: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '24px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      DEPRECATED <br />
      (more information coming soon)
    </div>
  );
};

export default Deprecated;
